import { getCampaignByCode } from '../requests/campaigns';
import { createQuery } from '../store';

const useGetCampaignByCode = (campaignCode: string) =>
  createQuery('getCampaignByCode', getCampaignByCode(campaignCode));

export { useGetCampaignByCode };
